import { defineMessages } from 'react-intl';

/**
 * "Post it" of a kit asset or a reel (the asset cards, the Studio result, the Work rows, the
 * viewer). The Library screen is gone (Releases v2); the native apps still render its other ids,
 * which live in `src/i18n/nativeMessages.ts`.
 */
export const libraryMessages = defineMessages({
  postIt: { id: 'app.sml.promote.library.postIt', defaultMessage: 'Post it' },
});
